// Angular modules
import { DatePipe, registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeIt from '@angular/common/locales/it';
import { HTTP_INTERCEPTORS, withFetch } from '@angular/common/http';
import { withInterceptorsFromDi } from '@angular/common/http';
import { provideHttpClient } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { withInMemoryScrolling } from '@angular/router';
import { withRouterConfig } from '@angular/router';

// External modules
import { provideTranslateService, TranslateModule } from '@ngx-translate/core';
import { TranslateLoader } from '@ngx-translate/core';
import { provideTranslateHttpLoader, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AngularSvgIconModule } from 'angular-svg-icon';


// Internal modules
import { environment } from '@env/environment';
import { routes } from './app.routes';

// Services
import { AppService } from '@services/app.service';
import { StoreService } from '@services/store.service';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';

import { fal } from '@fortawesome/pro-light-svg-icons';

import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

registerLocaleData(localeDe, 'de');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeIt, 'it');

export const appConfig: ApplicationConfig = {
  providers: [

    // Routing
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled'
      }),
    ),

    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'en',
      lang: environment.defaultLanguage
    }),

    importProvidersFrom(
      // Angular modules
      BrowserModule,

      // External modules
      AngularSvgIconModule.forRoot(),
      NgxDaterangepickerMd.forRoot(),

      // for HttpClient use:
      LoadingBarHttpClientModule,
      // for Router use:
      LoadingBarRouterModule,
      // for Core use:
      LoadingBarModule,

      // Internal modules
    ),

    // External modules

    // Services
    StoreService,
    AppService,

    // Pipes
    DatePipe,

    // Guards

    // Resolvers
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideAnimations(),
    provideClientHydration(),
  ],

};
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fal);
  }
}
